import { Box, FlosIcon, Link } from '@flos/react-ui';
import { useHippoText } from '../../hooks/useHippoText';
import { useState } from 'react';
import ViewInformationModal from '../ViewInformationModal/ViewInformationModal';
import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../recoil/selectors/getOnsaCurrentProductSelector';
import { numberOfFlavourCoverablesSelector } from '../../recoil/selectors/numberOfFlavourCoverablesSelector';
import { giftCertificateAtom } from '../../recoil/atoms/giftCertificateAtom';
import { topConfigContextAtom } from '../../recoil/atoms/topConfigContextAtom';
import { getOnsaCoverable } from '../../utils/coverablesUtil';
import { allCoverablesOnsaAtom } from '../../recoil/atoms/allCoverablesOnsaAtom';
import { COVERABLE_CODE } from '../../constants/coverable';
import { isGiftCardEligibleSelector } from '../../recoil/selectors/isGiftCardEligibleSelector';

export const GiftCertificateBanner = (): React.JSX.Element | null => {
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourCode, flavourName, fixedId } = currentProduct;
    const isGiftCardEligible = useRecoilValue(isGiftCardEligibleSelector);
    const allOnsaCoverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(allOnsaCoverables, flavourName, fixedId);
    const numberOfFlavourCoverables = useRecoilValue(
        numberOfFlavourCoverablesSelector(flavourName)
    );
    const giftCertificates = useRecoilValue(giftCertificateAtom);
    const getHippoText = useHippoText();
    const topConfigContext = useRecoilValue(topConfigContextAtom);

    const [showModal, setShowModal] = useState<boolean>(false);

    const value = giftCertificates?.[flavourCode];

    if (
        !isGiftCardEligible ||
        !currentProduct ||
        !value ||
        numberOfFlavourCoverables >= 5 ||
        !coverable.isAddedInOnsa
    ) {
        return null;
    }

    const modalText =
        flavourCode === COVERABLE_CODE.accident
            ? 'DSS-GIFT-MODAL-DESCRIPTION-ACCIDENT'
            : 'DSS-GIFT-MODAL-DESCRIPTION';

    const viewInformationModalGiftCertificate = {
        title: getHippoText('DSS-GIFT-MODAL-TITLE'),
        description: getHippoText(modalText, {
            value,
            flavour: flavourName.toLowerCase()
        }),
        secondDescription: getHippoText('DSS-GIFT-MODAL-DESCRIPTION-TWO')
    };

    return (
        <>
            <div className="u-spacing-inset-l--stretch-max">
                <Box className="u-bg-primary-1-base u-display-flex u-gap-x-5 u-spacing-inset-l u-flex-items-center">
                    <img
                        alt="GiftCertificate"
                        src={`${topConfigContext?.resourceUrl ?? ''}/images/gogift.svg`}
                        style={{ width: '108px', height: '106px' }}
                    />
                    <div className="u-display-flex@sm u-flex-items-center" style={{ flexGrow: 1 }}>
                        <div className="u-color-white" style={{ flexGrow: 1 }}>
                            <h4>
                                {getHippoText('DSS-GIFT-BANNER-TITLE', {
                                    value
                                })}
                            </h4>
                            <p>
                                {getHippoText('DSS-GIFT-BANNER-DESCRIPTION', {
                                    value
                                })}
                            </p>
                        </div>

                        <Link
                            theme="logo"
                            onClick={() => {
                                setShowModal(true);
                            }}
                            className="u-flex-justify-end"
                        >
                            <span className="u-display-flex u-gap-x-3 u-flex-items-center">
                                <FlosIcon
                                    shape="info"
                                    size="medium"
                                    className="u-spacing-stack-xs is-logo-blue u-display-block@sm u-display-none"
                                />
                                {getHippoText('DSS-COMMON-INFO')}
                            </span>
                        </Link>
                    </div>
                </Box>
            </div>
            <ViewInformationModal
                showModal={showModal}
                modalProps={viewInformationModalGiftCertificate}
                closeModal={() => {
                    setShowModal(false);
                }}
            />
        </>
    );
};

export default GiftCertificateBanner;
